import { render } from "./NoResult.vue?vue&type=template&id=d2ecd698&scoped=true"
import script from "./NoResult.vue?vue&type=script&lang=js"
export * from "./NoResult.vue?vue&type=script&lang=js"

import "./NoResult.vue?vue&type=style&index=0&id=d2ecd698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ecd698"]])

export default __exports__